import _ from "lodash";

require('../../bootstrap');

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

import Vue          from 'vue';
import ComponentSet from "../../ComponentSet";

import utils from "../../Utils";
import moment from 'moment';
import Constants from "../../Constants";
import {ValidationObserver, ValidationProvider} from "vee-validate";

const components = _.assign(ComponentSet, { DatePicker} );

// --------------------------------------------------------------
//                          主程式
// --------------------------------------------------------------
const app = new Vue({
    components: components,
    mixins: [utils],
    data: {
        searchForm:{
            type:1,
            keyword:'',
            name:'',
            className:'',
            title:'',
            content:'',
            postAt:'',
            postEndAt:'',
        }
    },
    created() {
    },
    beforeDestroy() {
    },
    mounted() {
        const _this = this
        // 取回該頁面需要用到的資料
        _this.retrieveSiteContentData(function (response) {
            _this.searchForm = _.get(response, 'data.Value.pageData.contentData.search', []) || []

            _this.clearNull()
            _this.$nextTick( () => {
                document.querySelectorAll('.rd-content').forEach(function (item) {

                    let more = item.closest('.rd-content-parent').querySelector('.rd-content-more')
                    if(item.scrollHeight > item.clientHeight){
                        more.style.display = 'show';
                    }else{
                        more.style.display = 'none';
                    }
                })
            })
        });
    },
    methods: {
        search(){
            this.clearNull()
            window.location.search = new URLSearchParams(this.searchForm).toString();
        },
        clearNull(){
            this.searchForm.keyword   = _.isNull(this.searchForm.keyword    ) ? "": this.searchForm.keyword;
            this.searchForm.name      = _.isNull(this.searchForm.name       ) ? "": this.searchForm.name;
            this.searchForm.className = _.isNull(this.searchForm.className  ) ? "": this.searchForm.className;
            this.searchForm.title     = _.isNull(this.searchForm.title      ) ? "": this.searchForm.title;
            this.searchForm.content   = _.isNull(this.searchForm.content    ) ? "": this.searchForm.content;
            this.searchForm.postAt    = _.isNull(this.searchForm.postAt     ) ? "": this.searchForm.postAt;
            this.searchForm.postEndAt = _.isNull(this.searchForm.postEndAt  ) ? "": this.searchForm.postEndAt;
        },
        openMore(event){
            event.currentTarget.closest('.rd-content-parent').querySelector('.rd-content').classList.remove('ellipsis')
            event.currentTarget.style.display = 'none'
        },
    }, // end of methods
    computed: {
        serverRoot() {
            return Constants.serverRoot
        },
        listData() {
            return _.get(this, 'contentData.list', []) || [];
        }
    }, // end of computed
}).$mount('#app');